module.exports = __webpack_public_path__ + "static/media/arb.794707d6.png";